document.addEventListener("DOMContentLoaded", () => {
  const form = document.getElementById("master-class-form");
  const submitButton = document.getElementById("submit-button");
  const masterClassHeader = document.querySelector(
    ".master-class-signup-form-header"
  );
  const masterClassSuccess = document.querySelector(
    ".master-class-signup-form-success"
  );

  const apiUrl =
    "https://c9n4euwcbl.execute-api.ap-south-1.amazonaws.com/Prod/masterclass-signup";

  const language = window.location.pathname.includes("/de") ? "de" : "en";

  form.addEventListener("submit", (event) => {
    event.preventDefault();

    // Clear previous error messages
    document.querySelectorAll(".error").forEach((el) => (el.textContent = ""));

    // Get form values
    const firstName = document.getElementById("first-name").value.trim();
    const lastName = document.getElementById("last-name").value.trim();
    const email = document.getElementById("email").value.trim();

    // Validate form
    let isValid = true;

    if (!firstName) {
      document.getElementById("first-name-error").textContent =
        "Please enter your first name";
      isValid = false;
    }

    if (!lastName) {
      document.getElementById("last-name-error").textContent =
        "Please enter your last name";
      isValid = false;
    }

    if (!email) {
      document.getElementById("email-error").textContent =
        "Please enter your email address";
      isValid = false;
    } else if (!isValidEmail(email)) {
      document.getElementById("email-error").textContent =
        "Please enter a valid email address";
      isValid = false;
    }

    if (!isValid) {
      return;
    }
    submitButton.disabled = true;
    submitButton.classList.add("loading");
    submitButton.innerHTML = `<span class="loader"></span>`;

    // Prepare data
    const formData = {
      first_name: firstName,
      last_name: lastName,
      email,
      language,
    };

    // Submit form
    fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          form.style.display = "none";
          masterClassHeader.style.display = "none";
          masterClassSuccess.style.display = "flex";
          return;
        }
        throw new Error(data.message || "Unexpected error occurred");
      })
      .catch((error) => {
        console.error("Error:", error);
        alert(
          "There was a problem submitting your form. Please try again later."
        );
      })
      .finally(() => {
        submitButton.disabled = false;
      });
  });

  // Helper function to validate email
  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
});
